import ICWarning from 'assets/icons/warning-icon.svg'
import CustomButton from 'components/Buttons/CustomButton'
import { Modal, ModalBody } from 'reactstrap'

const ModalConfirmation = ({
  isOpen,
  toggle,
  title,
  subTitle,
  methodName,
  onConfirm,
  btnColor,
}) => {
  return (
    <Modal centered toggle={toggle} isOpen={isOpen} data-testid="farmer-approval-modal">
      <ModalBody>
        <img src={ICWarning} alt="Warning Icon" />
        <h6 className="mt-4 fw-600">{title}</h6>
        <small>{subTitle}</small>
        <div className="d-flex gap-3 mt-4">
          <CustomButton
            onClick={() => toggle()}
            block
            outline
            color="secondary"
            className="btn-cancel"
            testId="farmer-approval-modal-cancel-button"
          >
            Batal
          </CustomButton>
          <CustomButton
            onClick={() => {
              onConfirm(methodName)
              toggle()
            }}
            block
            color={btnColor}
            testId="farmer-approval-modal-submit-button"
          >
            Lanjut
          </CustomButton>
        </div>
      </ModalBody>
    </Modal>
  )
}

export default ModalConfirmation
